/* src/app/private/components/student/student-hostel/student-hostel.component.scss */
/*# sourceMappingURL=student-hostel.component.css.map */
